module.exports = __webpack_public_path__ + "static/media/1003018.8ff6f1a7.jpg";